export default __webpack_public_path__ + "static/media/img1211.69f7c565.png";